/* eslint-disable */
//composant fonction qui se lance uniquement quand un job est lancé dans l'export
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { initialState } from '../../redux/reducers/contracts';
import { ParameterApi } from '../../utils/api';
import { Toast } from 'primereact/toast';
import { createGlobalStyle } from 'styled-components';
import 'primeicons/primeicons.css';
import Container from 'saur_ui_library/src/Atoms/Container/Container';

const WatchJobs = () => {
  //redux pour observer le lancement du job
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);
  const [completedValue, setCompletedValue] = useState('');
  const job = useSelector((state: typeof initialState) => state?.launchJob);

  const getStatus = async (jobId, runId) => {
    try {
      await ParameterApi.getJobStatus(jobId, runId).then((value: any) => {
        setCompletedValue(value.data.status);
        if (value.data.status === 'running') {
          getStatus(jobId, runId);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (completedValue === 'failed') {
      toastError.current?.show({
        severity: 'error',
        summary: 'Calcul Echoué',
        detail: ' Une erreur est survenue, veuillez réessayer plus tard',
        sticky: true,
      });
    } else if (completedValue === 'complete') {
      toastSucess.current?.show({
        severity: 'success',
        summary: 'Calcul Exécuté',
        detail:
          "Bonne nouvelle, votre dossier est prêt et vous pouvez le télécharger dès maintenant dans l'onglet partage ",
        sticky: true,
      });
    }
  }, [completedValue]);
  useEffect(() => {
    if (job.jobId !== '' && job.runId !== '') {
      getStatus(job.jobId, job.runId);
      sessionStorage.setItem('jobId', job.jobId);
      sessionStorage.setItem('runId', job.runId);
    } else {
      getStatus(
        sessionStorage.getItem('jobId'),
        sessionStorage.getItem('runId'),
      );
    }
  }, [job]);

  //fonction pour ne plus afficher le message d'erreur

  const ToastRemove = () => {
    sessionStorage.removeItem('jobId');
    sessionStorage.removeItem('runId');
  };

  return (
    <Container className='watchjobs' id='watchjobs'>
      <Styles />
      <Toast
        id='toast-success'
        ref={toastSucess}
        onRemove={() => ToastRemove()}
      />
      <Toast id='toast-error' ref={toastError} onRemove={() => ToastRemove()} />
    </Container>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
   .watchjobs{
     border: 1px solid #243977;
     .toast-error{
        color: white;    
     }
    }
}

`;
export default WatchJobs;
